import { getTenantList, TENANT } from '$services/api'
import { useRequest } from 'ahooks'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface TenantState {
  currentTenant?: TENANT
  tenants: TENANT[]
}

interface TenantAction {
  updateCurrentTenant: (tenantId: string) => void
}

type TenantStore = TenantState & TenantAction

const initialState: TenantState = {
  currentTenant: undefined,
  tenants: []
}

export const useTenantStore = create<TenantStore>()(
  persist(
    set => ({
      ...initialState,
      updateCurrentTenant: (tenantId: string) => {
        const currentTenant =
          initialState.tenants.find(tenant => tenant.id === tenantId) ??
          initialState.currentTenant
        set({ currentTenant })
      }
    }),
    { name: 'tenant-storage' }
  )
)

export const updateTenants = (tenants: TENANT[]) => {
  useTenantStore.setState({ tenants })
}

export const updateCurrentTenant = (tenantId: string) => {
  useTenantStore.setState(state => {
    const currentTenant =
      state.tenants.find(tenant => tenant.id === tenantId) ??
      initialState.currentTenant
    return { currentTenant }
  })
}

export const resetTenant = () => {
  useTenantStore.setState(initialState)
}

export const useTenants = () => {
  const { runAsync, loading, data } = useRequest(getTenantList, {
    manual: true,
    onSuccess: async ({ data }) => {
      updateTenants(data)
    }
  })

  const isEmpty = !data?.data.length && !loading

  return {
    fetchTenants: runAsync,
    isTenantListEmpty: isEmpty,
    isTenantFetching: loading
  }
}

export default useTenants
